import styles from "Pages/Setup/Scheduler/Components/AddSchedule/CronSelector/IntegrationOption/IntegrationOption.module.css";

interface IProps {
    integration: IIntegration;
    index: number;
    array: IIntegration[];
}

/** Options mapped in the select input in CronSelector.tsx */
export default function IntegrationOption({
    integration: i,
    index,
    array,
}: IProps) {
    const group = i.integration_group;

    // Render nothing if integration is marked hidden
    if (i.hidden) return null;

    return (
        <>
            {/* Display group if index is zero or group is not the same as previous */}
            {(index === 0 || group !== array[index - 1].integration_group) && (
                <option className={styles.group} disabled>
                    {group}
                </option>
            )}
            {/* Integration */}
            <option
                key={i.name + i.num_args}
                className={styles.integration}
                value={i.process}
                disabled={i.disabled}
            >
                &nbsp;&nbsp;{i.process}
            </option>
        </>
    );
}
